import axios from 'axios'
import router from './../router'

 

export const  solicitud_incorporacion = async (to, from, next) => {   

    try { 

        const url = `https://api.servel.cl/private/registroavanzado`
 
        const { data: { datos, error , statusCode} } = await axios.post(url) 

        // next() 
        if(statusCode == 200)
        {  
            return router.push({path: '/redirect'}) 
        } 
        if(statusCode == 201)
        {  
            next() 
        } 
        
        
        
    } catch (error) {
        
        console.error('Error al consultar por el usuario en el registro::', error)
        return router.push({path: 'error', query: { message : 'Error al Consultar el registro electoral'}}) 
        
    } 

}  